import {PopUpContext} from "../context/PopUpContext.tsx";
import * as React from "react";

export const usePopUp = () => {
	const ctx = React.useContext(PopUpContext)
	if (ctx != null) {
		return ctx
	}
	throw new Error('usePopUp must be used within a PopUpProvider')
}